import api from "services/api";
import { API_URL_VERSION } from "constants/environment";
import { toSearchFilter } from "utils/utils";

export const ENDPOINT_NOTIFICATIONS = API_URL_VERSION + "alertas";
export const ENDPOINT_NOTIFICATIONS_LIST = ENDPOINT_NOTIFICATIONS + "/listar";
export const ENDPOINT_NOTIFICATIONS_RESOLVE = ENDPOINT_NOTIFICATIONS + "/resolver";
export const ENDPOINT_NOTIFICATIONS_REOPEN = ENDPOINT_NOTIFICATIONS + "/reabrir";
export const ENDPOINT_NOTIFICATIONS_REMOVE_ISSUE = ENDPOINT_NOTIFICATIONS + "/remover-pendencia";
export const ENDPOINT_NOTIFICATIONS_INSERT_ISSUE = ENDPOINT_NOTIFICATIONS + "/inserir-pendencia";
export const ENDPOINT_NOTIFICATIONS_ASSIGN = ENDPOINT_NOTIFICATIONS + "/atribuir";
export const ENDPOINT_NOTIFICATIONS_USERS = ENDPOINT_NOTIFICATIONS+ "/usuarios";

export const TRAFFIC_VIOLATION_DOCUMENT_CREATED_TYPE = "CRIACAO_DOCUMENTO_INFRACAO";
export const PROCESS_CREATED_TYPE = "CRIACAO_PROCESSO";

export const NotificationsStatus = {
    ALL: { value: "", labelKey: "all" },
    NEW_AND_PENDING: { value: "OPENED", labelKey: "new-and-pending" },
    PENDING: { value: "PENDING", labelKey: "pending" },
    SOLVED: { value: "FINISHED", labelKey: "solved" },
};

export const notificationsService = {
    list: async (params = {}) => {
        try {
            const searchParams = toSearchFilter(params);
            const response = await api.post(ENDPOINT_NOTIFICATIONS_LIST, searchParams);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "alerts.messages.errors.list";
        }
    }, 

    find: async (id) => {
        try {
            const response = await api.get(`${ENDPOINT_NOTIFICATIONS}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "alerts.messages.errors.find";
        }
    }, 

    resolve: async (id) => {
        try {
            const response = await api.put(`${ENDPOINT_NOTIFICATIONS_RESOLVE}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "alerts.messages.errors.mark-as-resolved";
        }
    },

    reopen: async (id) => {
        try {
            const response = await api.put(`${ENDPOINT_NOTIFICATIONS_REOPEN}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "alerts.messages.errors.reopen";
        }
    },

    removeIssue: async (id) => {
        try {
            const response = await api.put(`${ENDPOINT_NOTIFICATIONS_REMOVE_ISSUE}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "alerts.messages.errors.remove-issue";
        }
    },

    insertIssue: async (notificationDTO) => {
        try {
            const response = await api.post(`${ENDPOINT_NOTIFICATIONS_INSERT_ISSUE}/${notificationDTO.id}`, notificationDTO);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "alerts.messages.errors.insert-issue";
        }
    },

    assign: async (notificationDTO) => {
        try {
            const response = await api.post(`${ENDPOINT_NOTIFICATIONS_ASSIGN}/${notificationDTO.id}`, notificationDTO);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "alerts.messages.errors.assign";
        }
    },

    listUsers: async () => {
        try {
            const response = await api.get(ENDPOINT_NOTIFICATIONS_USERS);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "alerts.messages.errors.assign";
        }
    },
};
